import React, { useState } from "react";

// Website editor -> SEO: how the store appears on Google. Empty fields use the defaults for the kind of store
// (shown as placeholders and in the preview), so an owner only writes what they want to change.
export default function SeoFields({ seo, defaults, domain, onChange }) {
  const [keyword, setKeyword] = useState("");
  const title = seo.title || defaults.title;
  const description = seo.description || defaults.description;
  const keywords = seo.keywords.length ? seo.keywords : defaults.keywords;
  const usingDefaults = !seo.keywords.length;

  const addKeyword = (e) => {
    e.preventDefault();
    const words = keyword.split(",").map((k) => k.trim()).filter(Boolean);
    if (!words.length) return;
    onChange({ keywords: [...new Set([...(usingDefaults ? [] : seo.keywords), ...words])].slice(0, 20) });
    setKeyword("");
  };

  return (
    <>
      <div className="field-section-title">How your store looks on Google</div>
      <div className="seo-preview" aria-label="Google preview">
        <small>{domain}</small>
        <b>{title}</b>
        <p>{description}</p>
      </div>

      <label className="admin-field">SEO title <span className={`seo-count ${title.length > 60 ? "warn" : ""}`}>{(seo.title || "").length}/70</span>
        <input value={seo.title} maxLength={70} onChange={(e) => onChange({ title: e.target.value })} placeholder={defaults.title} />
      </label>
      <small className="field-help">Best under 60 characters. Leave empty to use: {defaults.title}</small>

      <label className="admin-field">SEO description <span className={`seo-count ${description.length > 160 ? "warn" : ""}`}>{(seo.description || "").length}/170</span>
        <textarea rows="3" value={seo.description} maxLength={170} onChange={(e) => onChange({ description: e.target.value })} placeholder={defaults.description} />
      </label>
      <small className="field-help">One or two sentences about what you sell. Shown under the title on Google.</small>

      <div className="field-section-title">Keywords (tags)</div>
      <p className="field-help">{usingDefaults ? "Suggested keywords for your kind of store are used now. Add your own to replace them." : "Words people search for to find stores like yours."}</p>
      <div className="seo-tags">
        {keywords.map((k) => (
          <span key={k} className={usingDefaults ? "is-default" : ""}>
            {k}
            {!usingDefaults && <button type="button" aria-label={`Remove ${k}`} onClick={() => onChange({ keywords: seo.keywords.filter((x) => x !== k) })}>×</button>}
          </span>
        ))}
      </div>
      <form className="seo-add" onSubmit={addKeyword}>
        <input value={keyword} maxLength={100} onChange={(e) => setKeyword(e.target.value)} placeholder="e.g. buy dog food online, cat toys" />
        <button className="outline-btn" type="submit">Add</button>
      </form>
      {!usingDefaults && <button type="button" className="text-btn" onClick={() => onChange({ keywords: [] })}>Use the suggested keywords again</button>}
      <p className="field-help">Press Save changes to publish. Google can take a few days to show changes.</p>
    </>
  );
}
